import React, { useContext, useEffect, useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import UserDetailsForm from "./UserDetailsForm";
import CartItems from "./CartItems";
import PaymentFinal from "./PaymentFinal";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function Checkout() {
  const { isAuthenticated } = useContext(AuthContext);
  const [activeStep, setActiveStep] = useState(1);
  const [userDetails, setUserDetails] = useState({}); // State to hold user details
  const [usercartItems, setUserCartItems] = useState({}); // State to hold user details
  const [totalPrice, setTotalPrice] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, []);

  const handleNext = () => {
    setActiveStep((prevStep) => (prevStep < 3 ? prevStep + 1 : prevStep));
  };

  const handlePrev = () => {
    setActiveStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));
  };

  const handleUserDetailsSubmit = (values) => {
    setUserDetails(values); // Update userDetails state
    handleNext(); // Move to the next step
  };
  return (
    <>
      <Navbar />
      {isAuthenticated && (
        <div className="container">
          <div className="p-4">
            <h1 className="p-4 w-full font-secondaryFont font-semibold text-center underline underline-offset-[10px]">
              Checkout Process
            </h1>
            <div className="relative flex justify-between items-center w-full">
              <div className="top-2/4 left-0 absolute bg-gray-300 w-full h-0.5 -translate-y-2/4"></div>
              <div
                className={`   top-2/4 left-0 absolute bg-gray-900 w-full h-0.5 transition-all -translate-y-2/4 duration-500 ease-in`}
                style={{ width: `${(activeStep - 1) * 40 + 10}%` }}
              ></div>
              <div
                className={`relative z-10 place-items-center grid bg-gray-900 rounded-full w-10 h-10 font-bold text-white transition-all duration-300 ${
                  activeStep === 1 ? "bg-gray-500 text-white" : ""
                }`}
              >
                1
              </div>
              <div
                className={`relative z-10 grid w-10 h-10 font-bold text-white transition-all duration-300 bg-gray-900 rounded-full place-items-center ${
                  activeStep === 2 ? "bg-gray-500 text-white" : ""
                }`}
              >
                2
              </div>
              <div
                className={`relative z-10 grid w-10 h-10 font-bold text-white transition-all duration-300 bg-gray-900 rounded-full place-items-center ${
                  activeStep === 3 ? "bg-gray-500 text-white" : ""
                }`}
              >
                3
              </div>
            </div>
            <div className="flex justify-between my-2">
              <button
                className="bg-gray-900 focus:opacity-[0.85] active:opacity-[0.85] disabled:opacity-50 shadow-gray-900/10 shadow-md hover:shadow-lg hover:shadow-gray-900/20 focus:shadow-none active:shadow-none disabled:shadow-none px-6 py-3 rounded-lg font-bold font-sans text-center text-white text-xs uppercase transition-all disabled:pointer-events-none select-none align-middle"
                type="button"
                disabled={activeStep === 1}
                onClick={handlePrev}
              >
                Prev
              </button>
              {/* <button
          className="bg-gray-900 focus:opacity-[0.85] active:opacity-[0.85] disabled:opacity-50 shadow-gray-900/10 shadow-md hover:shadow-lg hover:shadow-gray-900/20 focus:shadow-none active:shadow-none disabled:shadow-none px-6 py-3 rounded-lg font-bold font-sans text-center text-white text-xs uppercase transition-all disabled:pointer-events-none select-none align-middle"
          type="button" disabled={activeStep === 3} onClick={handleNext}>
          Next
        </button> */}
            </div>
          </div>

          <div className="p-2">
            {/* Show components related to each step based on the activeStep */}
            {activeStep === 1 && (
              <CartItems
                nextProcess={handleNext}
                setCartData={setUserCartItems}
                setTotalPrice={setTotalPrice}
              />
            )}
            {activeStep === 2 && (
              <UserDetailsForm
                initialValues={userDetails}
                onSubmit={handleUserDetailsSubmit}
              />
            )}
            {activeStep === 3 && (
              <PaymentFinal
                billingInfo={userDetails}
                cartItems={usercartItems}
                totalPrice={totalPrice}
              />
            )}
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

export default Checkout;
